import { useToast } from '@airship-platform/airship-patterns';
import { LoadingButton } from '@airship-platform/jam-web/components';
import { ShareIcon } from '@airship-platform/jam-web/icons';

interface OwnProps {
  title: string;
  text: string;
  getShareLink: () => Promise<string | null>;
  loading: boolean;
}

const isShareSupported = () =>
  'share' in navigator && typeof navigator.share === 'function';

const NativeShareButton: React.FC<OwnProps> = ({
  title,
  text,
  getShareLink,
  loading,
}) => {
  const { showToast } = useToast();

  const handleShare = async () => {
    const url = await getShareLink();

    if (!url) {
      return;
    }

    try {
      await navigator.share({ title, text, url });
    } catch (error) {
      const dismissed =
        (error instanceof Error || error instanceof DOMException) &&
        (error.name === 'AbortError' || error.name === 'InvalidStateError');
      if (dismissed) {
        return;
      }
      showToast('We were unable to open the share sheet', 'warning');
    }
  };

  if (!isShareSupported()) {
    return null;
  }

  return (
    <LoadingButton
      color={'softGold'}
      startIcon={<ShareIcon />}
      onClick={handleShare}
      loading={loading}
    >
      Share
    </LoadingButton>
  );
};

export default NativeShareButton;
